import * as React from 'react';

const MoneyBoxIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#004A68"
        d="M21.333 14.359a.985.985 0 0 0 .72-.306.985.985 0 0 0 .306-.72.985.985 0 0 0-.306-.719.985.985 0 0 0-.72-.306.985.985 0 0 0-.719.306.985.985 0 0 0-.306.72c0 .275.102.514.306.719a.985.985 0 0 0 .72.306Zm-10.666-3.333h6.666V10h-6.666v1.026ZM7 26.666a580.04 580.04 0 0 0-1.99-6.929A24.944 24.944 0 0 1 4 12.667c0-1.669.583-3.086 1.749-4.252C6.915 7.25 8.332 6.667 10 6.667h7.333a8.044 8.044 0 0 1 2.043-1.903A4.721 4.721 0 0 1 22 4a.64.64 0 0 1 .468.199.64.64 0 0 1 .199.468.446.446 0 0 1-.025.143c-.016.048-.03.093-.04.136a8.367 8.367 0 0 0-.378 1.224c-.095.418-.181.838-.26 1.258l3.905 3.905H28v6.993l-3.51 1.156-2.157 7.185h-5V24H12v2.667H7Zm.782-1.025h3.192v-2.667h7.385v2.667h3.218l2.074-6.923 3.323-1.141v-5.218h-1.528l-4.472-4.472c.006-.504.052-.987.14-1.45.088-.462.207-.917.358-1.365a5.662 5.662 0 0 0-1.99.957 5.225 5.225 0 0 0-1.451 1.663H10c-1.388 0-2.564.482-3.528 1.447-.964.964-1.446 2.14-1.446 3.528 0 2.233.309 4.416.928 6.547a612.001 612.001 0 0 1 1.828 6.427Z"
      />
    </g>
  </svg>
);

export default MoneyBoxIcon;
